import { withRouter } from "react-router-dom";

import { compose } from "recompose";

import AnimalsInField from "./AnimalsInField";

export default compose(withRouter)(AnimalsInField);
